import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Product } from 'src/app/models/core/product.model';
import { isProductSoldOut } from 'src/app/utils/product-progress';
import { GenerateCodeModalComponent } from '../generate-code-modal/generate-code-modal.component';
import { SharePromotionalLinkComponent } from '../share-promotional-link/share-promotional-link.component';
import { Router } from '@angular/router';
import { GenerateTicketModalComponent } from '../generate-ticket-modal/generate-ticket-modal.component';

@Component({
  selector: 'app-product-options-modal',
  templateUrl: './product-options-modal.component.html',
  styleUrls: ['./product-options-modal.component.scss'],
  standalone: false
})
export class ProductOptionsModalComponent {
  @Input() product!: Product;
  @Input() eventId!: string;
  @Input() isTicketSold: boolean = false;
  @Input() isDirectSale: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private router: Router,
  ) { }

  get isProductComplete(): boolean {
    return !!this.product && isProductSoldOut(this.product);
  }

  get isExclusiveProduct(): boolean {
    return this.product?.restricted === 1;
  }

  get isPromotionalProduct(): boolean {
    return this.product?.promotional === 1;
  }

  selectDetails() {
    this.modalCtrl.dismiss({ action: 'details' });
  }

  async selectGenerateCode() {
    await this.modalCtrl.dismiss();

    const initialBreakpoint = 0.95;

    const modal = await this.modalCtrl.create({
      component: GenerateCodeModalComponent,
      componentProps: {
        product: this.product,
      },
      breakpoints: [0, 0.5, 0.75, 0.95],
      initialBreakpoint,
      cssClass: 'custom-modal-options',
      handle: true,
    });

    await modal.present();
  }

  async selectShareLink() {
    await this.modalCtrl.dismiss();
    const initialBreakpoint = 0.65;

    const modal = await this.modalCtrl.create({
      component: SharePromotionalLinkComponent,
      componentProps: {
        product: this.product,
      },
      breakpoints: [0, 0.5, 0.65, 0.75, 0.95],
      initialBreakpoint,
      cssClass: 'custom-modal-options',
      handle: true,
    });

    await modal.present();
  }


  goToProductTicketSoldInfo(productId: number) {
    this.modalCtrl.dismiss();
    if (this.eventId) {
      this.router.navigate([`/event-sales/${this.eventId}/all-sold-tickets`], {
        queryParams: { productId }
      });
    }
  }

  async selectGenerateTicket() {
    await this.modalCtrl.dismiss();
    await GenerateTicketModalComponent.open(this.modalCtrl, this.product);
  }
}
